export default {
  talkToSis: {
    title: 'Fale com a Gente!',
    description:
      'Quer conversar com um de nossos especialistas? Então fale com a gente. Temos uma equipe qualificada para atender as suas necessidades.',
    buttonText: 'Falar com a SIS',
  },
}
